import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route, useLocation } from "react-router-dom";
import { ACCOUNT_TYPE } from "./utils/constants";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ObservationList from "./pages/admin/ObservationList";
import UserManagement from "./pages/admin/UserManagement";
import Home from "./pages/Home";
import Login from "./components/Login/Login";
import Signup from "./components/Signup/Signup";
import OpenRoute from "./components/Auth/OpenRoute";
import PrivateRoute from "./components/Auth/PrivateRoute";
import Navbar from "./components/Navbar";
import { Dashboard } from "./pages/Dashboard";
import FeaturesPage from "./pages/FeaturesPage";
import Success from "./pages/success/success";
import Cancel from "./pages/cancel/cancel";
import MyProfile from "./components/Dashboard/MyProfile";
import Settings from "./components/Dashboard/Settings";
import UserDashboard from "./pages/user/UserDashboard";
import AreaManagementPage from "./pages/admin/AreaManagement";
import Error from "./pages/Error"
import ForgotPassword from "./pages/ForgetPassword/ForegetPassword";
import UpdatePassword from "./pages/ForgetPassword/UpdatePassword";
import Scroll_To_Top_Button from "./utils/scroll_To_Top_Button"
import "./index.css";
import MyActions from "./pages/admin/ActionPage";
import UserMyAction from "./pages/user/MyAction"
import WaitingPage from "./pages/statusPage/WaitingPage"
import InProgressPage from "./pages/statusPage/InProgressPage"
import SubmitPage from "./pages/statusPage/SubmitPage"
import CompletePage from "./pages/statusPage/CompletedPage"
import SubmitObservation from "./pages/user/SubmitObservation";
import MyCoaching from "./pages/user/MyCoaching";
import CoachingLibrary from "./pages/admin/CoachingVideo";
import Games from "./pages/admin/Game"
import MyObservation from "./pages/user/MyObservation";
import NotificationsPage from "./pages/Notification";
import ObservationPage from "./pages/user/ObservationPage";

import SuperDashboard from "./pages/superAdmin/superDashboard";
import Plants from "./pages/superAdmin/Plants";
import GameManagement from "./pages/admin/GameManagement";
// import LandingPage from "./pages/landingPage/App"

function App() {
  const { user } = useSelector((state) => state.profile)
  return (
    <>
      
      <div className="">
            <Navbar />
            <div className="p-4">
              <Routes>
                <Route path="/" element={<Home />} />
               
              <Route path="/login" element={<OpenRoute><Login /></OpenRoute>} />
              <Route path="/signup" element={<OpenRoute><Signup /></OpenRoute>} />
              <Route path="/forgotPassword" element={<OpenRoute><ForgotPassword /></OpenRoute>}/>
              <Route path="update-password/:id"element={<OpenRoute><UpdatePassword /></OpenRoute>}/>
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/success" element={<Success />} />
              <Route path="/failure" element={<Cancel />} />
              
                <Route path="/employee/submit-observation/:adminId" element={<ObservationPage/>}/>
              <Route element={<PrivateRoute><Dashboard /></PrivateRoute>}>

              <Route path="dashboard/my-profile" element={<MyProfile />} />
              <Route path="dashboard/Settings" element={<Settings />} />
             

              <Route path="/my-action/waiting/:observationId" element={<WaitingPage/>}/>
              <Route path="/my-action/in-progress/:observationId" element={<InProgressPage/>}/>
              <Route path="/my-action/submitted/:observationId" element={<SubmitPage/>}/>
              <Route path="/my-action/completed/:observationId" element={<CompletePage/>}/>
              <Route path="/bbs/coaching-library" element={<CoachingLibrary/>}/>
              <Route path="/bbs/games" element={<Games/>}/>
              <Route path="/bbs/notification" element={<NotificationsPage/>}/>
              
              {
                user?.accountType === ACCOUNT_TYPE.SUPERADMIN && (
                  <>
                  <Route path='/super-dashboard' element={<SuperDashboard/>} />
                  <Route path='/plants' element={<Plants/>}/>
                  <Route path="/my-actions" element={<MyActions/>}/>
                  <Route path="/bbs/games/create" element={<GameManagement />} />
                  <Route path="/bbs/coaching-library" element={<CoachingLibrary/>}/>
                  </>
                )
              }
              {
        user?.accountType === ACCOUNT_TYPE.ADMIN && (
          <>

                <Route path="/admin-dashboard" element={<AdminDashboard />} />
                <Route path="/admin/area" element={<AreaManagementPage />} />
                <Route path="/admin/area/observations/:areaId" element={<ObservationList />} />
                <Route path="/bbs/games/create" element={<GameManagement />} />
                <Route path="/bbs/coaching-library" element={<CoachingLibrary/>}/>
                <Route path="/admin/add-users" element={<UserManagement />} />
                <Route path="/admin/my-actions" element={<MyActions/>}/>
              </>
        )}

                {
                user?.accountType === ACCOUNT_TYPE.EMPLOYEE && (
                <>
                
                <Route path="/user-dashboard" element={<UserDashboard />} />
                <Route path="/user/observation" element={<MyObservation/>}/>
                <Route path="/employee/my-actions" element={<UserMyAction/>}/>
                <Route path="/employee/submit-observation" element={<SubmitObservation/>}/>
                <Route path="/coaching/my-coaching" element={<MyCoaching/>}/>  
                
                {/* <Route path="/user/audit/:auditId" element={<AuditDetailPage />} />
                <Route path="/user/audit/:auditId/create-report" element={<SubmitReportPage />} />
                <Route path="/audit/:auditId/closure" element={<ClosurePage />} /> */}
                

                </>
                )}
                </Route>
                <Route path="*" element={<Error />} />
              </Routes>
              <Scroll_To_Top_Button/>
            </div>
          </div>
       
    </>
  );
}

export default App;
